import { Tutor } from '@/types';

function hashString(input: string) {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function getInitials(name?: string) {
  const cleaned = String(name || '').trim();
  if (!cleaned) return '?';
  const parts = cleaned.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '?';
  const second = (parts.length > 1 ? parts[parts.length - 1]?.[0] : parts[0]?.[1]) || '';
  return (first + second).toUpperCase();
}

function pickColors(tutor?: Tutor | null) {
  const gender = tutor?.gender || 'PREFER_NOT_TO_SAY';
  const nameSeed = String(tutor?.name || '');
  const n = hashString(nameSeed);

  const palettes: Record<string, Array<{ bg: string; ring: string }>> = {
    MALE: [
      { bg: '#2563EB', ring: '#1D4ED8' }, // blue
      { bg: '#0EA5E9', ring: '#0284C7' }, // sky
      { bg: '#14B8A6', ring: '#0F766E' }, // teal
    ],
    FEMALE: [
      { bg: '#EC4899', ring: '#DB2777' }, // pink
      { bg: '#F97316', ring: '#EA580C' }, // orange
      { bg: '#A855F7', ring: '#7C3AED' }, // purple
    ],
    NON_BINARY: [
      { bg: '#4F46E5', ring: '#4338CA' }, // indigo
      { bg: '#22C55E', ring: '#16A34A' }, // green
      { bg: '#06B6D4', ring: '#0891B2' }, // cyan
    ],
    PREFER_NOT_TO_SAY: [
      { bg: '#64748B', ring: '#475569' }, // slate
      { bg: '#4F46E5', ring: '#4338CA' }, // indigo
      { bg: '#0EA5E9', ring: '#0284C7' }, // sky
    ],
  };

  const list = palettes[gender] || palettes.PREFER_NOT_TO_SAY;
  return list[n % list.length];
}

function makeSvgDataUrl(initials: string, bg: string, ring: string) {
  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
  <circle cx="64" cy="64" r="62" fill="${bg}"/>
  <circle cx="64" cy="64" r="62" fill="none" stroke="${ring}" stroke-width="4" opacity="0.65"/>
  <text x="64" y="66" text-anchor="middle" dominant-baseline="middle"
    font-family="Manrope, Segoe UI, system-ui, sans-serif"
    font-size="48" font-weight="700" fill="#FFFFFF" letter-spacing="1">
    ${initials}
  </text>
</svg>`.trim();
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export function getTutorAvatarUrl(tutor?: Tutor | null) {
  const url = tutor?.profilePhotoUrl?.trim();
  if (url) return url;

  const initials = getInitials(tutor?.name);
  const { bg, ring } = pickColors(tutor);
  return makeSvgDataUrl(initials, bg, ring);
}
